import { useState } from 'react';
import { Box, Chip, Grid, Stack, Typography } from '@mui/material';
import apartmentIcon from '@/assets/images/svg/apartment.svg';
import homeWorkIcon from '@/assets/images/svg/home-work.svg';
import interactiveSpaceIcon from '@/assets/images/svg/interactive-space.svg';
import { ConfirmDialog } from '@/components/shared/confirm-dialog';
import { ModalitiesLabels } from '@/constants/recommendation';
import { Modalities } from '@/models/recommendation';

const options = [
  { value: Modalities.Presencial, icon: apartmentIcon },
  { value: Modalities.Hybrid, icon: homeWorkIcon },
  { value: Modalities.Distance, icon: interactiveSpaceIcon },
];

interface ModalitiesEditDialogProps {
  currentValues: Modalities[];
  onClose: () => void;
  onSave: (modalities: Modalities[]) => void;
}

export const ModalitiesEditDialog = ({
  currentValues,
  onClose,
  onSave,
}: ModalitiesEditDialogProps) => {
  const [selectedModalities, setSelectedModalities] = useState<Modalities[]>(
    currentValues || []
  );

  const handleSave = () => {
    onSave(selectedModalities);
  };

  const toggleModality = (value: Modalities) => {
    setSelectedModalities((prev) =>
      prev.includes(value)
        ? prev.filter((modality) => modality !== value)
        : [...prev, value]
    );
  };

  return (
    <ConfirmDialog
      actionLabels={{
        cancel: 'Cancelar',
        confirm: 'Salvar',
      }}
      onClose={onClose}
      open
      onConfirm={handleSave}
      title="Modalidades"
      maxWidth="xs"
      disableConfirmButton={selectedModalities.length === 0}
    >
      <Stack direction="row" justifyContent="space-between" mb={2}>
        <Typography>Selecione até 3 opções</Typography>
        <Typography>{selectedModalities.length} / 3</Typography>
      </Stack>
      <Grid container spacing={2} columns={12}>
        {options.map(({ value, icon }) => {
          const isSelected = selectedModalities.includes(value);
          return (
            <Grid key={value} size={6}>
              <Chip
                sx={{
                  height: '100%',
                  maxWidth: 180,
                  py: 1,
                  px: 2,
                  width: '100%',
                  justifyContent: 'center',
                }}
                variant="outlined"
                color={isSelected ? 'secondary' : 'default'}
                onClick={() => toggleModality(value)}
                label={
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    gap={1}
                  >
                    <Box
                      component="img"
                      src={icon}
                      alt={ModalitiesLabels[value]}
                    />
                    <Typography>{ModalitiesLabels[value]}</Typography>
                  </Box>
                }
              />
            </Grid>
          );
        })}
      </Grid>
    </ConfirmDialog>
  );
};
